var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('binding-wizard-modal',{attrs:{"role-options":_vm.roleOptions,"manufacturer-options":_vm.manufacturerOptions,"add-action":_vm.addAction}})}
var staticRenderFns = []

export { render, staticRenderFns }